import { memo, type FC } from 'react';
import { InlineLink } from 'InlineLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { type LearnerProject } from './LearnerProjects.types';

const ProjectLinksComponent: FC<{ project: LearnerProject; locked: boolean; titleSize?: 'base' | 'xs' | 'sm' }> = ({
    project,
    locked,
    titleSize = 'base',
}) => (
    <div className="flex flex-col gap-2">
        {project.projectDocuments.map(document => {
            const textContent = `${document.title}${!locked ? ' (PDF)' : ''}`;
            const words = textContent.split(' ');
            const lastWord = words.pop();
            const firstWords = words.join(' ');

            return (
                <InlineLink
                    key={document.id}
                    href={document.url}
                    download={document.fileFileName}
                    color={locked ? 'slate-grey' : 'primary'}
                    underline={locked ? 'none' : 'always'}
                    disabled={locked}
                    className={`${locked ? 'opacity-100' : ''} ${
                        titleSize === 'xs' ? 'text-xs' : titleSize === 'sm' ? 'text-sm' : 'text-base'
                    }`}
                    weight="medium"
                >
                    {firstWords}
                    {firstWords && ' '}
                    <span className="whitespace-nowrap">
                        {lastWord}
                        <FontAwesomeIcon
                            className={`ms-1 inline-block ${locked ? '-mt-0.5' : 'rtl:rotate-180'}`}
                            icon={locked ? faLock : faArrowRight}
                        />
                    </span>
                </InlineLink>
            );
        })}
    </div>
);

export const ProjectLinks = memo(ProjectLinksComponent) as typeof ProjectLinksComponent;
